var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Messages',{attrs:{"id":"thread-messages","thread-id":_vm.threadId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }